/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { ActionsTable } from "ceco-window-table";
import { FilterDeleteModal } from "../../modals/FilterDeleteModal";
import { FiltersModal } from "../../modals/FiltersModal";
import { MoreHorizontal, Edit, Delete } from "ceicons";
import DropDownButton from "../../DropDownButton";
import _ from "lodash";

import "./FiltersTable.scss";

export default function FiltersTable(props) {
  const { _refetch, labelParsed, handleScroll } = props;
  const t = useTranslation();

  const columnsTable = [
    {
      key: "name",
      basis: 1,
      width: 200,
      title: t("table-header.name"),
      ItemRenderer: NameCell,
    },
    {
      key: "options",
      basis: 1,
      title: t("table-header.options"),
      ItemRenderer: OptionsCell,
    },
    {
      key: "id",
      basis: 1,
      width: 100,
      ItemRenderer: <EditCell refetchData={_refetch} />,
    },
  ];

  return (
    <ActionsTable
      actions={[]}
      allowItemSelection={false}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      items={labelParsed}
      columns={columnsTable}
      flags={labelParsed}
      onScrollTable={handleScroll}
    />
  );
}

const EditCell = (props) => {
  const { data, rowIndex, style, refetchData } = props;
  const { flags } = data;

  const id = flags[rowIndex].id;
  const name = flags[rowIndex].name;
  const label = flags[rowIndex].labels.edges;

  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        flexDirection: "row",
        padding: "1em",
        border: "",
      }}
      className="edit cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <FiltersModal
          label={{ id, name, label }}
          refetchData={refetchData}
          edit
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />
        <FilterDeleteModal
          filterName={name}
          refetchData={refetchData}
          filterId={id}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
        />
      </DropDownButton>
    </div>
  );
};

const OptionsCell = (props) => {
  const { rowIndex, style, data } = props;
  const { flags } = data;

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        flexDirection: "row",
        border: "",
      }}
      className="options cell"
    >
      {_.map(flags[rowIndex].labels.edges, (item) => (
        <p key={item.node.id} className="options_item">
          {item.node.name}
        </p>
      ))}
    </div>
  );
};

const NameCell = (props) => {
  const { rowIndex, style, data } = props;
  const { flags } = data;

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        flexDirection: "row",
        border: "",
      }}
      className="cell"
    >
      <p className="name">{flags[rowIndex].name}</p>
    </div>
  );
};
